import classNames from "classnames";
import React from "react";
import { useTheme } from "../../../contexts/ThemeContext";
import logoblack from "./logo-black.svg";
import logowhite from "./logo-white.svg";

interface LogoProps {
  align: "left" | "center";
}

export const Logo: React.FC<LogoProps> = ({ align }) => {
  const { effectiveTheme } = useTheme();
  const logoSrc = effectiveTheme === "dark" ? logowhite : logoblack;

  return (
    <img
      className={classNames({
        "mx-auto": align === "center",
        "w-auto": align === "center",
      })}
      src={logoSrc}
      alt="transcriptor.ai"
      width={150}
    />
  );
};
